"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicService = void 0;
const APIService_1 = require("./APIService");
const APIService_2 = require("./APIService");
const login = (username, password) => APIService_1.APIService.post(`/login`, {
    username,
    password,
});
const verify = () => APIService_2.APIAuthService.post(`/verify`);
const getCompanyFromGUS = (nip) => APIService_1.APIService.get(`/gus?nip=${nip}`);
const getProvinces = () => APIService_1.APIService.get('/address/provinces');
const getProvince = (province) => APIService_1.APIService.get(`/address/provinces/${province}`);
const getCity = (province, city) => APIService_1.APIService.get(`/address/provinces/${province}/cities/${city}`);
const getCitiesByProvinceSlug = (province) => APIService_1.APIService.get(`/address/provinces/${province}/cities`);
const getCoordinators = () => APIService_1.APIService.get(`/coordinators`);
exports.PublicService = {
    login,
    verify,
    getCompanyFromGUS,
    getProvince,
    getProvinces,
    getCity,
    getCitiesByProvinceSlug,
    getCoordinators,
};
//# sourceMappingURL=PublicService.js.map